import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    title: 'Hoe kunnen we je helpen?',
    label: '<strong>Hoe meer jij typt, hoe beter onze AI werkt.</strong>  Persoonlijke vragen zijn nog niet mogelijk.',
    placeholder: 'Begin met typen...',
    resetAriaLabel: 'Wissen',
    submitAriaLabel: 'Begin je gesprek',
    submitText: 'Begin je gesprek',
  },
  en: {},
};
